import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BannerComponent } from "./banner/banner.component";
import { MenuComponent } from "./menu/menu.component";
import { FooterComponent } from "./footer/footer.component";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { CarouselSectComponent } from "./carousel-sect/carousel-sect.component";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { ShopSectionComponent } from "./shop-section/shop-section.component";
import { PopularSliderComponent } from "./popular-slider/popular-slider.component";
import { PopularProductGridComponent } from './popular-product-grid/popular-product-grid.component';
import { MailLiastComponent } from './mail-liast/mail-liast.component';

@NgModule({
  imports: [CarouselModule, CollapseModule.forRoot(), CommonModule],
  exports: [
    BannerComponent,
    MenuComponent,
    FooterComponent,
    CarouselSectComponent,
    ShopSectionComponent,
    PopularSliderComponent,
    PopularProductGridComponent,
    MailLiastComponent
  ],
  declarations: [
    BannerComponent,
    MenuComponent,
    FooterComponent,
    CarouselSectComponent,
    ShopSectionComponent,
    PopularSliderComponent,
    PopularProductGridComponent,
    MailLiastComponent,
  ],
})
export class SharedModule {}
